import type {
  QcIncidentPcbaProductFamily,
  QcIncidentPcbaTlaVariant,
} from "@/pages/manufacturing/qcIncidentsApi";
import { normalizeConfigurationSkuForFamilyDetection } from "@integrator-src/manufacturing/configuration-sku-family";

/** Maps configure target SKU to PCBA QC incident product line. */
export function inferPcbaProductFamilyFromConfigureSku(sku: string): QcIncidentPcbaProductFamily | "" {
  const upper = normalizeConfigurationSkuForFamilyDetection(sku);
  if (upper === "") return "";
  if (upper.startsWith("FI-3C-B")) return "fi_3c_b";
  if (upper.startsWith("FI-3C-Q")) return "fi_3c_q";
  if (upper.startsWith("FI-3C")) return "fi_3c_n";
  if (upper.startsWith("FI-5A-W")) return "fi_5a_w";
  if (upper.startsWith("FI-5A")) return "fi_5a_n";
  if (upper.startsWith("DM-1")) return "dm_1";
  return "";
}

/** Parses clamp TLA variant (A/C) from a required TLA SKU such as FI-3C-N-TLA-A. */
export function inferPcbaTlaVariantFromTlaSku(tlaSku: string | null | undefined): QcIncidentPcbaTlaVariant | "" {
  const trimmed = (tlaSku ?? "").trim();
  if (trimmed === "") return "";
  const match = /-TLA-([AC])\b/i.exec(trimmed);
  if (match?.[1]?.toUpperCase() === "A") return "A";
  if (match?.[1]?.toUpperCase() === "C") return "C";
  return "";
}

export function configurationPreConfigQcIssueNotes(input: {
  batchItemId: number | null;
  alternateOrderId?: number | null;
}): string {
  if (input.batchItemId != null) {
    return `Configuration for batch item ${input.batchItemId}. Filed before scan complete. Reported issue: `;
  }
  if (input.alternateOrderId != null) {
    return `Configuration for alternate order ${input.alternateOrderId}. Filed before scan complete. Reported issue: `;
  }
  return "Configuration job. Filed before scan complete. Reported issue: ";
}
